import { makeAutoObservable, runInAction } from "mobx";
import i18n from "i18next";
import MainStore from "MainStore";
import { login, getUser, recoveryPassword, getMyRoles } from "../../api/Auth/useAuth";
import { jwtDecode } from "jwt-decode";

class NewStore {
  login = "";
  loginForRecovery = "";
  errorloginForRecovery = "";
  password = "";
  errorPassword = "";
  navigate: (path: string) => void = () => { };
  
  constructor() {
    makeAutoObservable(this);
  }

  setNavigateFunction(navigate: (path: string) => void) {
    this.navigate = navigate;
  }

  handleChange(event) {
    const { name, value } = event.target;
    (this as any)[name] = value;
  }

  onLogin = async () => {
    try {
      MainStore.changeLoader(true);
      
      const data = {
        Username: this.login,
        Password: this.password,
      };
      
      this.errorPassword = "";
      const response = await login(data);

      if (response.status === 201 || response.status === 200) {
        if (response.data) {
          const { token } = response.data;
          localStorage.setItem('token', token);
          
          const decodedToken = jwtDecode(token);
          localStorage.setItem("currentUser", decodedToken.sub);
          
          // Инициализируем данные пользователя (загружаем GetMe и роли)
          const initSuccess = await MainStore.initializeUser();
          
          if (initSuccess) {
            // Очищаем форму логина
            this.clearStore();
            
            // Перенаправляем пользователя
            window.location.href = "/user";
            window.location.reload();
          } else {
            // Если не удалось загрузить данные пользователя
            this.errorPassword = "error";
            MainStore.setSnackbar(
              i18n.t("message:cannotLoadUserData") || "Не удалось загрузить данные пользователя", 
              "error"
            );
          }
        } else {
          this.errorPassword = "error";
        }
      } else {
        throw new Error();
      }
    } catch (err) {
      console.error("Login error:", err);
      this.errorPassword = "error";
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  };

  onRecoveryPassword = async () => {
    try {
      MainStore.changeLoader(true);
      
      const data = {
        Email: this.loginForRecovery,
      };
      
      this.errorloginForRecovery = "";
      const response = await recoveryPassword(data);

      if (response.status === 201 || response.status === 200) {
        if (response.data) {
          MainStore.setSnackbar(i18n.t("message:recoveryPasswordSendEmail"), "success");
          this.clearStore();
        } else {
          MainStore.setSnackbar(i18n.t("message:recoveryPasswordFailSendEmail"), "error");
        }
      } else {
        throw new Error();
      }
    } catch (err) {
      console.error("Recovery password error:", err);
      MainStore.setSnackbar(i18n.t("message:somethingWentWrong"), "error");
    } finally {
      MainStore.changeLoader(false);
    }
  };

  clearStore = () => {
    runInAction(() => {
      this.login = "";
      this.loginForRecovery = "";
      this.password = "";
      this.errorPassword = "";
      this.errorloginForRecovery = "";
    });
  };
}

export default new NewStore();